'use client';

// imports
import { useAtom } from 'jotai';

// lib files
import { appSignInAtom, defaultAppSignInState } from '@/lib/atoms/app-sign-in';
import { useHasMounted } from '@/lib/hooks';

// components
import Button from '@/components/Button/Button';

// styles
import styles from './AppSignInError.module.scss';

const AppSignInError = () => {
  const [ _, setAppSignInState ] = useAtom(appSignInAtom);
  const handleTryAgain = () => setAppSignInState({
    ...defaultAppSignInState
  })
  const hasMounted = useHasMounted();

  if (!hasMounted) {
    return null;
  }

  return (
    <div className={styles.app_sign_in_error}>
      <h2>{`We're sorry, there was a problem with sign in.`}</h2>
      <Button
        size='responsive'
        onClick={handleTryAgain}
        style='white'
      >
        Try Again
      </Button>
    </div>
  );
};

export default AppSignInError;
